import React, { useEffect, useState } from "react";
import ResetPasswordForm from "./ResetPasswordForm";
import { useErrorHandler } from "react-error-boundary";
import { useMutation } from "react-query";
import { resetPassword } from "../../../queries/session";
import { createErrors } from "../../../queries/helpers";
import { parse } from "query-string";
import { FORM_ERROR } from "final-form";

const ResetPasswordPage = ({ history, toast }) => {
  const handleError = useErrorHandler();
  const [jwt, setJwt] = useState(null);

  useEffect(() => {
    setJwt(parse(location.search).token);
  }, []);

  const changePassword = useMutation(async (formData) => {
    await resetPassword(formData);
  });

  const onSubmit = async (values) => {
    values.password_confirmation = values.password;
    values.jwt = jwt;
    return await changePassword
      .mutateAsync(values)
      .then(() => {
        toast.success("Your password updated successfully!");
        history.push("/login");
      })
      .catch((error) => {
        if (error.request.status === 404) {
          return { [FORM_ERROR]: "Link is not valid" };
        } else {
          toast.error([
            {
              title: "Password Reset failed",
              body: `${error.response.data.errors
                .map((error) => error.detail)
                .join(", ")}`,
            },
          ]);
          return createErrors(error, "Password Reset failed", handleError);
        }
      });
  };
  return (
    <div className="fs-wrap fs-form">
      <ResetPasswordForm onSubmit={onSubmit} />
    </div>
  );
};

ResetPasswordPage.propTypes = {};

export default ResetPasswordPage;
